/*
 Created by qing on 2020/12/29
 Des:
 */

import {uuid} from "../RyDashBoard/utils"
import {CONFIG_TYPE__DEFAULT} from "./type";
import {CHART_TYPE__FILTER_CONTROL} from "../RyDashBoard/types";
import {arrayRemove, clone} from "../../assets/js/Untis";
import BaseChart from "../RyDashBoard/BaseChart";

class BaseConfig {
  constructor(id) {

    // 是否加载完成
    this.isLoad = true
    // 父级
    this.parent = null
    // 鼠标进入
    this.isHover = false
    // 是否需要先编辑才能放入仪表盘
    this.toEdit = true
    // 用来保存图表数据
    this.value = null

    // 内容确定后回调
    this.toEditCallback = () => {
    }
    // 最小宽
    this.minW = 10
    // 最小高
    this.minH = 3
    // 最大宽
    // this.maxW = 60
    // 最大高
    // this.maxH = 24
    // 最大宽
    this.maxW = 1000
    // 最大高
    this.maxH = 1000

    // 是否 铺满 el-main 修改 header 以及 header 返回按钮
    this.isBespread = false

    this.i = id || uuid('CONFIG')

    this.configName = ''

    this.x = 0
    this.y = 0
    this.w = 30
    this.h = 18

    this.pX = 0
    this.pY = 0

    this.hidden = 0
    this.errorPrompt = '暂无数据'
  }

  get configId() {
    return this.i
  }
}

BaseConfig.prototype.configType = CONFIG_TYPE__DEFAULT
BaseConfig.prototype.getBase = function () {
  return {
    configType: this.configType,
    configName: this.title,
    configId: this.configId,

    offsetX: this.x,
    offsetY: this.y,
    width: this.w,
    height: this.h,

    pX: this.pX,
    pY: this.pY,
    pH: this.pH,
    pW: this.pW,
    hidden: this.hidden
  }
}
BaseConfig.prototype.setBase = function (opts) {

  const {
    configType,
    configName,
    configId,

    offsetX,
    offsetY,
    width,
    height,
    hidden
  } = opts

  this.configType = configType
  this.configName = configName
  this.i = configId

  this.x = offsetX
  this.y = offsetY
  this.w = width
  if(this.configType == 'TODO'){
	  this.w = 60
  }
  this.h = height

  this.hidden = hidden || 0
}

BaseConfig.prototype.edit = function () {
  this.parent.editingItem = this
  this.parent.edited = true
}
BaseConfig.prototype.remove = function () {

  this.parent.children.some((item, i) => {
    if (item.i === this.i) {
      this.parent.children.splice(i, 1)
      return true
    } else {
      return false
    }
  })
  this.parent.edited = true
}

export default BaseConfig
